import { ValidCouponCodes } from 'store/signup/signup.types';

import { WM_FLOWS } from 'constants/onboarding';
import { FlowTypes } from 'utils/enums';

import { PlanCodes } from 'models/plans.types';

export const SIGNUP_COUPON_CODES: {
  [key in ValidCouponCodes]:
    | string
    | {
        discount: {
          unit: 'absolute' | 'percentage' | 'months' | 'advanced';
          value: string;
        };
        flowsAllowed: 'All' | FlowTypes[];
        hasSubCodes: boolean;
        periodsAllowed: 'All' | number[];
        plansAllowed: 'All' | { code: string; plan: PlanCodes }[];
      };
} = {
  '4health25': {
    discount: {
      unit: 'percentage',
      value: '25%'
    },
    flowsAllowed: 'All',
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: 'All'
  },
  '4health50': {
    discount: {
      unit: 'percentage',
      value: '50%'
    },
    flowsAllowed: 'All',
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: 'All'
  },
  '4health75': {
    discount: {
      unit: 'percentage',
      value: '75%'
    },
    flowsAllowed: 'All',
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: 'All'
  },
  '74OFF1MO': {
    discount: {
      unit: 'absolute',
      value: '74'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP74FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  app25: {
    discount: {
      unit: 'advanced',
      value: '25%offOnAppointment'
    },
    flowsAllowed: 'All',
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [
      { code: 'app25', plan: PlanCodes.UrgentCare },
      { code: 'app25', plan: PlanCodes.FlexCare },
      { code: 'app25', plan: PlanCodes.LifeMDMembership }
    ]
  },
  cleared50: {
    discount: {
      unit: 'advanced',
      value: '50%offOnAppointmentOrFirstMonth'
    },
    flowsAllowed: 'All',
    hasSubCodes: true,
    periodsAllowed: 'All',
    plansAllowed: [
      { code: 'firstmonth50tc', plan: PlanCodes.TotalCareMembership },
      { code: 'firstmonth50fc', plan: PlanCodes.FlexCare },
      { code: 'firstmonth50cc', plan: PlanCodes.ConciergeMembership }
    ]
  },
  clearedcovered: {
    discount: {
      unit: 'advanced',
      value: '100%offOnAppointmentOrFirstMonth'
    },
    flowsAllowed: 'All',
    hasSubCodes: true,
    periodsAllowed: 'All',
    plansAllowed: [
      { code: 'firstmonthfreetotal', plan: PlanCodes.TotalCareMembership },
      { code: 'firstmonthfreeflex', plan: PlanCodes.FlexCare },
      { code: 'firstmonthfreeconcierge', plan: PlanCodes.ConciergeMembership }
    ]
  },
  firstmonthfree: {
    discount: {
      unit: 'months',
      value: '1'
    },
    flowsAllowed: 'All',
    hasSubCodes: true,
    periodsAllowed: [3, 12],
    plansAllowed: [
      { code: 'firstmonthfreetotal', plan: PlanCodes.TotalCareMembership },
      { code: 'firstmonthfreeconcierge', plan: PlanCodes.ConciergeMembership }
    ]
  },
  firstmonthfreeconcierge: {
    discount: {
      unit: 'months',
      value: '1'
    },
    flowsAllowed: 'All',
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'firstmonthfreeconcierge', plan: PlanCodes.ConciergeMembership }]
  },
  firstmonthfreetotal: {
    discount: {
      unit: 'months',
      value: '1'
    },
    flowsAllowed: 'All',
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'firstmonthfreetotal', plan: PlanCodes.TotalCareMembership }]
  },
  freebct: 'AT-HOME BREAST CANCER DETECTION',
  freeccs: 'FREE TEST KIT APPLIED',
  GLP1F137REC: {
    discount: {
      unit: 'absolute',
      value: '150'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP150FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP1F1266REC: {
    discount: {
      unit: 'absolute',
      value: '1188'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP1F1266REC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP74FLATREC: {
    discount: {
      unit: 'absolute',
      value: '74'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP74FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP100FLATREC: {
    discount: {
      unit: 'absolute',
      value: '100'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP100FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP115REC: {
    discount: {
      unit: 'percentage',
      value: '15%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP115REC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP125REC: {
    discount: {
      unit: 'percentage',
      value: '25%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP125REC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP133REC: {
    discount: {
      unit: 'percentage',
      value: '33%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP133REC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP137REC: {
    discount: {
      unit: 'percentage',
      value: '37%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP137REC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP150OFF: {
    discount: {
      unit: 'percentage',
      value: '50%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP150OFF', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP150REC: {
    discount: {
      unit: 'percentage',
      value: '50%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP150REC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP200FLATREC: {
    discount: {
      unit: 'absolute',
      value: '200'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP200FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP250OFF: {
    discount: {
      unit: 'percentage',
      value: '25%'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP250OFF', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP398FLATREC: {
    discount: {
      unit: 'absolute',
      value: '398'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP398FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLP498FLATREC: {
    discount: {
      unit: 'absolute',
      value: '498'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLP498FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLPBH59FLATREC: {
    discount: {
      unit: 'absolute',
      value: '59'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLPBH59FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  GLPBH222FLATREC: {
    discount: {
      unit: 'absolute',
      value: '222'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'GLPBH222FLATREC', plan: PlanCodes.WeightManagementMembership }]
  },
  LFMD30OFF: {
    discount: {
      unit: 'absolute',
      value: '30'
    },
    flowsAllowed: [FlowTypes.TripleTherapy],
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: 'All'
  },
  rex50: {
    discount: {
      unit: 'advanced',
      value: '50%offOnAppointmentOrFirstMonth'
    },
    flowsAllowed: 'All',
    hasSubCodes: true,
    periodsAllowed: 'All',
    plansAllowed: [
      { code: 'firstmonth50tc', plan: PlanCodes.TotalCareMembership },
      { code: 'firstmonth50fc', plan: PlanCodes.FlexCare },
      { code: 'firstmonth50cc', plan: PlanCodes.ConciergeMembership }
    ]
  },
  WEG300FLAT: {
    discount: {
      unit: 'absolute',
      value: '300'
    },
    flowsAllowed: WM_FLOWS,
    hasSubCodes: false,
    periodsAllowed: 'All',
    plansAllowed: [{ code: 'WEG300FLAT', plan: PlanCodes.WeightManagementMembership }]
  }
};
